import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { ChangeEvent, useEffect, useState } from "react";
import { useAddRewardsMutation, useLazyGetRewardsQuery, useUpdateRewardsMutation } from "../../services/advertiser";
import { Loader, showError, showToast } from "../../constants";
import { isNumber, isString } from "../../utils/validations";
import { GiftsResponse, RewardsResponse } from "../../types/General";
import { UploadMedia } from "../../utils/mediaUpload";
import { useEditGiftByIdMutation, useLazyGetGiftByIdQuery, usePostGiftMutation } from "../../services/gifts";
import useTranslation from "../../hooks/Translation";

const AddGifts = () => {
  const {id}=useParams()
  const navigate = useNavigate();

  const [gift, setGift] = useState<GiftsResponse>();  
  const [image, setImage] = useState<string>("");
  const [error, setError] = useState<boolean>(false);

  const [addGift]=usePostGiftMutation();
  const [getGift, { isLoading }] = useLazyGetGiftByIdQuery();
  const [updateGift]=useEditGiftByIdMutation()
  const translations=useTranslation()as any

  const formik=useFormik({
    enableReinitialize:true,
    initialValues:{
      title:gift?.title||"",
      title_ar:gift?.title_ar||"",
      
      giftWorth:gift?.cost||"",

    },

    validationSchema: Yup.object({
      title: Yup.string()
        .required(translations.Globals.field_req)
        .min(2, translations.Globals.min_2),
      title_ar: Yup.string()
      .required(translations.Globals.field_req)
      .min(2, translations.Globals.min_2),
        giftWorth: Yup.string()
        .required(translations.Globals.field_req)
     
    }),
    

    onSubmit:async(values)=>{
      formik.setSubmitting(true);
      const body={
        title: values?.title,
        title_ar:values.title_ar,
        image:image,        
        cost:Number(values?.giftWorth),
        appKey: new Date().toISOString(),
      }

    
        if(id){         
          try{
            const resposne:any=await updateGift({
              body,
              id
            }).unwrap()        
      
            if(resposne?.statusCode===200){
              showToast(translations.Globals.gift_update)
              navigate('/manage-gifts')
            }     
              }catch(error:any){
          showError(error?.data?.message || "")
        }
          }else{
  
          try{
          const resposne:any=await addGift(
            body
          ).unwrap()
    
          if(resposne?.statusCode===200){
            showToast(translations.Globals.gift_add)
            navigate('/manage-gifts')
          }
    
    
      }catch(error:any){
        showError(error?.data?.message || "")
      }
        } 
          }
  })


  const getGiftDetails=async(id:string)=>{
    try {
      const response: any = await getGift({
        id
      });
   
      if (response?.data?.statusCode === 200) {
        setGift(response?.data?.data);
        setImage(response?.data?.data?.image)
        
      } 
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  }


 

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
  };
  useEffect(()=>{
    if(id){
      getGiftDetails(id)
    }
  },[])

   

  return (
    <>
      <MainContainer>
        <Loader isLoad={isLoading}/>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{id?translations.manage_gifts.edit||"":translations.manage_gifts.add||""}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-gifts");
              }}
            >
              {translations.Globals.back||""}
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography className="custom_label">{translations.manage_gifts.image||""}</Typography>
                    {image ? (
                      <div className="upload_image_preview">
                        <CardMedia component="img" image={image} alt="photo" />
                        <CancelIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setImage("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src={
                                image
                                  ? image
                                  : "/static/images/user_placeholder.png"
                              }
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                    {error && !image ? (
                      <h6 className="err_msg">{translations.Globals.field_req}</h6>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {" "}
                      {translations.manage_gifts.title_eng||""}<span className="asterisk">*</span>
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="title"
                      variant="outlined"
                      inputProps={{ maxLength: 30 }}
                      fullWidth
                      placeholder= {translations.manage_gifts.title_eng||""}
                      value={formik.values.title}
                      onBlur={formik.handleBlur}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                          
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        <h6 className="err_msg">

                          {formik.touched.title && formik.errors.title}
                        </h6>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {" "}
                      {translations.manage_gifts.title_arb||""}<span className="asterisk">*</span>
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="title_ar"
                      variant="outlined"
                      fullWidth
                      placeholder={translations.manage_gifts.title_arb||""}
                      inputProps={{ maxLength: 30 }}
                      value={formik.values.title_ar}
                      onBlur={formik.handleBlur}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                          
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        <h6 className="err_msg">

                          {formik.touched.title_ar && formik.errors.title_ar}
                        </h6>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                    {translations.manage_gifts.gift_worth||""}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="giftWorth"
                      variant="outlined"
                      fullWidth
                      inputProps={{ maxLength: 10 }}
                      placeholder={translations.manage_gifts.gift_worth||""}
                      onBlur={formik.handleBlur}
                      value={formik.values.giftWorth}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isNumber(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        <h6 className="err_msg">

                          {formik.touched.giftWorth && formik.errors.giftWorth}
                        </h6>
                      }
                    />
                  </Grid>
                 
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    onClick={() => setError(true)}
                  >
                    {translations.Globals.save||""}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default AddGifts;
